export const handler = (el, e) => {
  e.preventDefault();
  window.print();
};
